import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const EditorStats = lazy(() => import('.'))

class EditorStatsWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['target-language-id']
	}

	override render() {
		const targetLanguageId = this.prop('target-language-id') || null

		return (
			<RootProviders>
				<EditorStats targetLanguageId={targetLanguageId} />
			</RootProviders>
		)
	}
}

customElements.define('editor-stats', EditorStatsWebComponent)
